import { ScanAction } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const scanItems = {
  name: "scanItems" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    actions: z.array(
      z.object({
        action: createEnum(ScanAction, { enumName: "ScanAction" }),
        lineItemExternalId: z.string(),
        quantity: z.number(),
        serialNumbers: z.array(z.string()).optional(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
